const apps = {
  appToolbar: {
    all:'All',
    android:'Android',
    ios:'iOS',
    favorite:'Favorite',
    banned:'Banned',
    appIsBanned:'app is banned',
    allApps:'All apps',
    googlePlayApps:'Google Play apps',
    appStoreApps:'App Store apps',
    favoriteApps:'Favorite apps',
    bannedApps:'Banned apps',
  },
  appList: {
    addNewApp:'Add new app',
    shown:'Shown',
    appsFrom:'apps from',
    added:'added',
    found:'Found',
    applicationsBySearch:'applications by search',
    nothingFoundBySearch:'Nothing found by search',
    startWithAddingNewApplication:'Start with adding new application',
  },
  appItem: {
    unavailable:'Unavailable',
    promote:'Promote',
    createKeywordsCampaign:'Create keywords campaign',
    createDirectInstallsCampaign:'Create direct installs campaign',
    createReviewCampaign:'Create review campaign',
    createCpiCampaign:'Create CPI campaign',
    addKeywords:'Add keywords',
    refreshApp:'Refresh app',
    deleteApp:'Delete app',
    applicationId:'Application id',
    downloads:'Downloads',
    category:'Category',
    contentRating:'Content rating',
    applicationIsNotRemoved:'Application is not removed from store',
  },
  appstoreToggle: {
    store:'Store',
    googlePlay:'Google Play',
    appStore:'App Store',
  },
  countrySelect: {
    country:'Country',
  },
  appSelect: {
    pleaseEnterApplicationPackage:'Please enter application package, trackid or store URL',
    beforeAddingNewApplication:'Before adding a new application, please check the following',
    appIsFree:'The app is free on the App Store (we can’t promote paid iOS apps)',
    appIsAvailableInSelectedCountry:'The app is either free or paid on Google Play (paid apps are allowed there)',
    appDoesntRequireSystemPermissions:'The app is available in the selected country and doesn’t require any special permissions',
  },
  appDropdown: {
    quickActions:'Quick actions',
    update:'Update',
    updating:'Updating...',
    delete:'Delete',
    myKeywords:'My keywords',
    statistics:'Statistics',
    externalAnalytics:'External Analytics',
    showInAppfollow:'Show in Appfollow',
    showInAsoMobile:'Show in AsoMobile',
    showInAsoTools:'Show in AsoTools',
  }
};
export default apps;
